import { Link } from 'react-router-dom';

const Footer2 = () => {
  return (
    <footer className='footer-2 px-[10px] md:px-[50px] lg:px-[70px] xl:px-[100px] bg-[#F1F8FF]'>
      <div>
        <Link to="https://wa.me/628983862898" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/CS.png`} alt="FamilyMart Indonesia" className="fixed bottom-5 right-5 w-[60px] md:w-[70px] lg:w-[70px] xl:w-[100px]"
        /></Link>
      </div>
      <div className='flex justify-between px-5 md:px-0'>
        <div className='flex md:block justify-between mt-3 md:mt-0'>
          <div>
            <p className='text-sm lg:text-xl xl:text-2xl text-sky-500 font-extrabold'>Let's get in touch!</p>
            <div className='flex items-center mt-2 md:mt-5 mb-0 md:mb-3'>
              <div><img src={`${process.env.PUBLIC_URL}/media/images/Whatsapp.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px] mr-3" alt="FamilyMart Indonesia" /></div>
              <Link to="https://wa.me/628983862898" target={"_blank"} className='text-sky-500 font-bold text-xs md:text-sm'>0898-3862-898</Link>
            </div>
          </div>
        </div>
        <div className='flex md:block justify-between mt-3 md:mt-0'>
          <div>
            <p className='text-sm lg:text-xl xl:text-2xl text-sky-500 font-extrabold text-right'>Find us on:</p>
            <div className='flex items-center justify-end mt-2 md:mt-5'>
              <Link to="https://www.instagram.com/familymartid/" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/Instagram.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px]" alt="FamilyMart Indonesia" /></Link>
              <Link to="https://web.facebook.com/FamilyMartID" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/Facebook.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px]" alt="FamilyMart Indonesia" /></Link>
              <Link to="https://www.tiktok.com/@familymartindonesia" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/Tiktok.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px]" alt="FamilyMart Indonesia" /></Link>
              <Link to="https://x.com/FamilyMart_ID" target={"_blank"}><img src={`${process.env.PUBLIC_URL}/media/images/Twitter.png`} className="w-[30px] md:w-[45px] lg:w-[45px] xl:w-[60px]" alt="FamilyMart Indonesia" /></Link>
            </div>
          </div>
        </div>
      </div>
      <hr className="border-1 md:border-2 border-solid border-cyan-600 my-2" />
      <p className='text-sky-500 text-xs md:text-sm'>Copyright &copy; 2022 PT Fajar Mitra Indah</p>
    </footer>
  );
};

export default Footer2;